import {Capacitor} from "@capacitor/core"

export type CapacitorPlugin = {
  isNativeApp: () => boolean
}

export default {
  isNativeApp() {
    return Capacitor.isNativePlatform()
  }
}
